const url = '/service-attributes';
const Provider = 'ServiceAttributes';
const dbModel = 'ServiceAttributes';

export { url, Provider, dbModel };
